import { render, staticRenderFns } from "./HeroTitle.vue?vue&type=template&id=0aaf0d56&scoped=true&"
import script from "./HeroTitle.vue?vue&type=script&lang=js&"
export * from "./HeroTitle.vue?vue&type=script&lang=js&"
import style0 from "./HeroTitle.vue?vue&type=style&index=0&id=0aaf0d56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf0d56",
  null
  
)

export default component.exports